module.exports = __webpack_public_path__ + "img/44.d7468b80.jpg";